































































































import Vue from 'vue';
import sum from 'lodash/sum';
import Ship from '@/classes/fleet/ship';

export default Vue.extend({
  name: 'ShipTooltip',
  props: {
    value: {
      type: Ship,
      required: true,
    },
    fleetRosCorr: {
      type: Number,
      default: 0,
    },
    isFlagship: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    baseHP(): number {
      const ship = this.value;
      return ship.level > 99 ? ship.data.hp2 : ship.data.hp;
    },
    buffHP(): number {
      return this.value.hp - this.baseHP;
    },
    baseAsw(): number {
      const ship = this.value;
      return ship.level === 99 ? ship.data.maxAsw : Ship.getStatusFromLevel(ship.level, ship.data.maxAsw, ship.data.minAsw);
    },
    buffAsw(): number {
      return this.value.asw - this.baseAsw;
    },
    maxAsw(): number {
      const ship = this.value;
      return Ship.getStatusFromLevel(ship.level, ship.data.maxAsw, ship.data.minAsw) + 9;
    },
    baseLuck(): number {
      return this.value.data.luck;
    },
    buffLuck(): number {
      return this.value.luck - this.baseLuck;
    },
    maxLuck(): number {
      return this.value.data.maxLuck;
    },
    taihaRate(): string {
      // ワンパン大破率
      let count = 0;
      const curHP = this.baseHP + this.buffHP;
      const border = Math.floor(curHP / 4);
      for (let i = 0; i < curHP; i += 1) {
        const damage = Math.floor(curHP * 0.5 + i * 0.3);
        const hp = curHP - damage;
        if (hp <= border) {
          count += 1;
        }
      }
      return `${((100 * count) / curHP).toFixed(1)} %`;
    },
    chuhaRate(): string {
      // ワンパン中破率
      let count = 0;
      const curHP = this.baseHP + this.buffHP;
      const border = Math.floor(curHP / 4);
      const border2 = Math.floor(curHP / 2);
      for (let i = 0; i < curHP; i += 1) {
        const damage = Math.floor(curHP * 0.5 + i * 0.3);
        const hp = curHP - damage;
        if (border < hp && hp <= border2) {
          count += 1;
        }
      }
      return `${((100 * count) / curHP).toFixed(1)} %`;
    },
    specialAttacks(): { text: string; rate: number[] }[] {
      if (this.fleetRosCorr) {
        const array = this.value.getDayBattleSpecialAttackRate(this.fleetRosCorr, this.isFlagship);
        if (array.length) {
          array.push({ text: 'Total', rate: [sum(array.map((v) => v.rate[0])), sum(array.map((v) => v.rate[1]))] });
        }

        array.forEach((v) => {
          v.rate = v.rate.map((x) => Math.round(1000 * x) / 10);
        });
        return array;
      }
      return [];
    },
  },
});
